import { render } from "./NewPublishPost.vue?vue&type=template&id=1458ae8a&scoped=true"
import script from "./NewPublishPost.vue?vue&type=script&lang=js"
export * from "./NewPublishPost.vue?vue&type=script&lang=js"

import "./NewPublishPost.vue?vue&type=style&index=0&id=1458ae8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1458ae8a"]])

export default __exports__